import { render, staticRenderFns } from "./Audio_1.vue?vue&type=template&id=eb074870&scoped=true"
import script from "./Audio_1.vue?vue&type=script&lang=js"
export * from "./Audio_1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb074870",
  null
  
)

export default component.exports